import { render } from "./FillInTheBlanksQuestion.vue?vue&type=template&id=6ac3484f"
import script from "./FillInTheBlanksQuestion.vue?vue&type=script&lang=js"
export * from "./FillInTheBlanksQuestion.vue?vue&type=script&lang=js"

import "./FillInTheBlanksQuestion.vue?vue&type=style&index=0&id=6ac3484f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__